module.exports = __webpack_public_path__ + "static/img/pin-adulticide-active.1839305.svg";